<template>
  <el-collapse
    v-model="accordionActiveItem"
    accordion
  >
    <el-collapse-item
      v-for="(analysis, index) in analyses"
      :key="index"
      :name="index"
    >
      <template slot="title">
        {{ analysis.code }} - {{ analysis.description }}
      </template>

      <!-- Analysis-level editable fields. Edited once here and stamped FLAT -->
      <!-- onto every operation value of this analysis in buildPayload -->
      <!-- (lowercase keys per the BE contract). The per-analysis -->
      <!-- accreditedTest may differ from the report-wide accredited flag. -->
      <el-row :gutter="20">
        <el-col :span="6">
          <FormItem :label="$t('advancedRevision.wizard.accredited')">
            <el-switch v-model="analysis.extra.accreditedTest" />
          </FormItem>
        </el-col>
        <el-col :span="6">
          <FormItem :label="$t('advancedRevision.wizard.methodCode')">
            <el-input v-model="analysis.extra.methodCode" />
          </FormItem>
        </el-col>
        <el-col
          v-if="analysis.extra.hasDilution"
          :span="6"
        >
          <FormItem :label="$t('advancedRevision.wizard.dilution')">
            <el-select
              v-model="analysis.extra.dilution"
              placeholder="Select"
              style="width: 100%"
            >
              <el-option
                v-for="opt in dilutionOptions"
                :key="opt.value"
                :label="opt.label"
                :value="opt.value"
              />
            </el-select>
          </FormItem>
        </el-col>
        <el-col :span="6">
          <FormItem :label="$t('advancedRevision.wizard.locationId')">
            <el-select
              v-model="analysis.extra.locationid"
              filterable
              placeholder="Select"
              style="width: 100%"
            >
              <el-option
                v-for="loc in locations"
                :key="loc.id"
                :label="loc.name"
                :value="loc.id"
              />
            </el-select>
          </FormItem>
        </el-col>
        <el-col :span="12">
          <FormItem
            :label="$t('advancedRevision.wizard.analysisTranslationIt')"
          >
            <el-input
              v-model="analysis.extra.analysisTranslation.it"
              type="textarea"
              :rows="2"
            />
          </FormItem>
        </el-col>
        <el-col :span="12">
          <FormItem
            :label="$t('advancedRevision.wizard.analysisTranslationEn')"
          >
            <el-input
              v-model="analysis.extra.analysisTranslation.en"
              type="textarea"
              :rows="2"
            />
          </FormItem>
        </el-col>
      </el-row>

      <!-- Main-result operation values — shared FormOperationValue (which -->
      <!-- itself embeds FormSpecifications for the specifiche editor). -->
      <div
        v-for="operation in mainResultOperations(analysis)"
        :key="
          operation.operationRegistryId + '-' + operation.labSampleAnalysisId
        "
      >
        <p class="section-subtitle">{{ operation.operation }}</p>

        <FormOperationValue
          :operationValue="operation.value"
          :operation="operation"
          :sample="sample"
          editable-symbol-type
        />
      </div>

      <!-- Diluenti e terreni — same FormOperationValue component, with the -->
      <!-- result column hidden (these operations carry no main result). It -->
      <!-- already renders the medium / tipo medium / lotto editors. -->
      <template v-if="terrainOperations(analysis).length">
        <h2 class="section-subtitle">
          {{ $t('advancedRevision.wizard.terrains') }}
        </h2>
        <div
          v-for="operation in terrainOperations(analysis)"
          :key="
            'terrain-' +
            operation.operationRegistryId +
            '-' +
            operation.labSampleAnalysisId
          "
        >
          <p class="section-subtitle">{{ operation.operation }}</p>

          <FormOperationValue
            :operationValue="operation.value"
            :operation="operation"
            :sample="sample"
            :has-value="false"
            editable-symbol-type
          />
        </div>
      </template>
    </el-collapse-item>
  </el-collapse>
</template>

<script>
  import { DILUTIONS } from '@/config/constants';
  import FormItem from '@/components/FormItem.vue';
  import FormOperationValue from '@/components/FormOperationValue.vue';

  export default {
    name: 'RevisionAnalysesStep',
    components: { FormItem, FormOperationValue },
    props: {
      analyses: { type: Array, required: true },
      sample: { type: Object, required: true },
      locations: { type: Array, default: () => [] },
    },
    data() {
      return {
        accordionActiveItem: 0,
      };
    },
    computed: {
      dilutionOptions() {
        return Object.values(DILUTIONS).map((val) => ({
          value: val,
          label: this.$t(`enums.dilutions.${val}`),
        }));
      },
    },
    methods: {
      mainResultOperations(analysis) {
        return (analysis.operationsWithValues || []).filter(
          (owv) => owv.mainResult
        );
      },
      // Non-main-result operations = diluents / terrains (medium, type, lot).
      terrainOperations(analysis) {
        return (analysis.operationsWithValues || []).filter(
          (owv) => !owv.mainResult
        );
      },
    },
  };
</script>
